import { useTooltipInPortal } from '@visx/tooltip';
import React from 'react';

interface ChartBase {
  width: number;
  height: number;
  children: React.ReactNode;
}
const ChartBase = ({ width, height, children }: ChartBase) => {
  const { containerRef } = useTooltipInPortal({
    scroll: true,
    detectBounds: true,
  });

  const childArray = React.Children.toArray(children).filter(React.isValidElement);
  const body = childArray.find((child) => child.type === Body);
  const legend = childArray.filter((child) => child.type === Legend);
  const footer = childArray.filter((child) => child.type === Footer);

  return (
    <div
      ref={containerRef}
      className='relative'
    >
      <div className='relative overflow-clip'>
        <div style={{ width, height }}>
          <svg
            aria-hidden='true'
            width={width}
            height={height}
            className='absolute top-0'
          >
            {body}
          </svg>
        </div>
      </div>
      <div style={{ width }}>{legend}</div>
      <div style={{ width }}>{footer}</div>
    </div>
  );
};

const Body = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

const Legend = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

const Footer = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

ChartBase.displayName = 'ChartBase';
ChartBase.Body = Body;
ChartBase.Legend = Legend;
ChartBase.Annotations = Footer;
ChartBase.Tooltip = Footer;

export { ChartBase };
